(function () {
  "use strict";

  function PackageParser() {
    var PackageParser = {};

    var packageModel = {
      idImportacao: null,
      destinatario: {
        nome: null,
        email: null,
        cpf: null,
        cnpj: null,
        inscricaoEstadual: null,
        endereco: {
          cep: null,
          bairro: null,
          logradouro: null,
          numero: null,
          cidade: null,
          estado: null,
          complemento: null,
          referencia: null,
        },
      },
      remetente: {
        nome: null,
        email: null,
        cpf: null,
        cnpj: null,
        inscricaoEstadual: null,
        endereco: {
          cep: null,
          bairro: null,
          logradouro: null,
          numero: null,
          cidade: null,
          estado: null,
          complemento: null,
          referencia: null,
        },
      },
      observacao: null,
      situacao: null,
      chaveAcessoNfe: null,
      tipoDocumentoOrigem: null,
      numeroPedidoLoja: null,
      referencia: null,
      formaEnvio: {
        codigo: null,
        altura: null,
        largura: null,
        comprimento: null,
        peso: null,
        valorDeclarado: null,
        avisoRecebimento: null,
        maoPropria: null,
        codigoRastreamento: null,
      },
      qrCodes: [],
      quantidadeVolumes: null,
    };

    PackageParser.parse = function (oldCollection) {
      return _.map(oldCollection, function (item) {
        var order = {};
        order = _.pick(item, [
          "destinatario",
          "remetente",
          "observacao",
          "idImportacao",
          "formaEnvio",
          "tipoDocumentoOrigem",
          "chaveAcessoNfe",
          "numeroPedidoLoja",
          "quantidadeVolumes",
          "idItemParceiro",
          "referencia",
        ]);
        order = _.assign({}, packageModel, order);
        if (order.destinatario.endereco.cep) {
          order.destinatario.endereco.cep = order.destinatario.endereco.cep.replace(
            /-/,
            ""
          );
        }

        order.referencia = order.referencia !== null ? order.referencia : order.idImportacao;
        return order;
      });
    };

    return PackageParser;
  }

  angular.module("mandaeApp").factory("PackageParser", PackageParser);
})();
